import { IComponentController, IRootScopeService } from 'angular';
import { Subscription } from 'rxjs';
import { UserModel } from '../../tn.common';
import { UserService } from '../../tn.user/service.tn.user';
import navBarTemplate from './navBar2.html';

type WatcherDestroyFunc = () => void;

export class NavBarController implements IComponentController {
    // href targets for nav links, constructed from cmsBaseURl
    // so it can be injected.
    public links = {
        editorial: this.cmsBaseURl + '/',
        services: this.cmsBaseURl + '/services',
        foundries: this.cmsBaseURl + '/type-foundries',
        designers: this.cmsBaseURl + '/font-designers',
        stories: this.cmsBaseURl + '/articles',
        search: this.cmsBaseURl + '/search',
    };

    public user?: UserModel;
    public isLoggedIn: boolean;

    // root scope watchers to destroy.
    private watchers: WatcherDestroyFunc[] = [];
    protected loginSubscription: Subscription;
    protected logoutSubscription: Subscription;
    protected scrapAnchor = document.createElement('a');

    public static $inject = ['$rootScope', 'tn.user.service', 'cmsBaseURl'];
    public constructor(
        protected $rootScope: IRootScopeService,
        protected userService: UserService,
        protected cmsBaseURl: string
    ) {
        this.user = this.userService.getUser();
        this.isLoggedIn = this.userService.isLoggedIn();
        this.userService.user$.subscribe((user) => {
            this.user = user;
        });

        // TODO: update user service to issue these events, and listen to it instead.
        this.loginSubscription = this.userService.login$.subscribe((user) =>
            this.onLogin(user)
        );
        this.logoutSubscription = this.userService.logout$.subscribe(() =>
            this.onLogout()
        );
    }

    protected onLogin(user: UserModel): void {
        this.isLoggedIn = true;
        this.user = user;
    }

    protected onLogout(): void {
        this.isLoggedIn = false;
    }

    public $onDestroy(): void {
        // remove any lingering watchers.
        this.watchers.forEach((destroyWatcher) => destroyWatcher());
        this.loginSubscription.unsubscribe();
        this.logoutSubscription.unsubscribe();
    }

    public login(): void {
        this.userService.oauthLogin();
    }

    public logout(): void {
        this.userService.oauthLogout();
    }

    public accountButtonPressed(): void {
        const isLoggedIn = this.userService.isLoggedIn();
        if (!isLoggedIn) {
            this.login();
        }
    }

    public releaseHijacked(): void {
        this.userService.releaseHijacked();
    }
}

export const navBarComponent = {
    controller: NavBarController,
    template: navBarTemplate,
    bindings: {},
};
